import React, { useState } from 'react';

interface Props {
  appendSymbol?: string;
  className?: string;
  defaultValue?: string | null;
  disabled?: boolean;
  error?: string;
  hint?: string;
  inputType?: string;
  label?: string;
  onBlur?: (value: string | number | undefined) => void;
  onChange?: (value: string | number | undefined) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  placeholder?: string;
  prependSymbol?: string;
  type?: 'text' | 'search';
}

const Input = ({
  appendSymbol,
  className,
  defaultValue,
  disabled,
  error,
  hint,
  inputType,
  label,
  onBlur,
  onChange,
  onKeyDown,
  placeholder,
  prependSymbol,
  type,
}: Props) => {
  const [input, setInput] = useState(defaultValue || '');

  return (
    <div className={className}>
      <raul-input
        // @ts-expect-error: children "does not exist on type"
        // eslint-disable-next-line react/no-children-prop
        children={
          <input
            disabled={disabled}
            onBlur={
              onChange
                ? (ev: React.ChangeEvent<HTMLInputElement>): void =>
                    onChange(ev.target.value)
                : () => {}
            }
            onChange={
              onBlur
                ? (ev: React.ChangeEvent<HTMLInputElement>): void =>
                    onBlur(ev.target.value)
                : () => {}
            }
            onInput={(e) => setInput(e.currentTarget.value)}
            onKeyDown={
              onKeyDown
                ? (ev: React.KeyboardEvent): void => onKeyDown(ev)
                : () => {}
            }
            placeholder={placeholder}
            type={inputType || 'text'}
            value={input}
          />
        }
        append-symbol={appendSymbol}
        error={error || ''}
        hint={hint || ''}
        label={label || ''}
        prepend-symbol={prependSymbol}
        type={type || 'text'}
      />
    </div>
  );
};

export default Input;
